import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { initializeGoogleAdsTag } from './utils/googleAds';
import { initializeMetaPixel } from './utils/metaPixel';
initializeGoogleAdsTag();
initializeMetaPixel();
render(<ErrorBoundary data-id="element-1992" data-mp="26avec0otkj2n">
    <App data-id="element-1993" data-mp="2677pheubkku9" />
  </ErrorBoundary>, document.getElementById('root'));